<template>
  <div class="test-sn-container" :class="{ 'is-mobile': isMobile }">
    <!-- 电脑端视图 - 全新美化版 -->
    <div v-if="!isMobile" class="desktop-view">
      <!-- 顶部操作栏 - 标题和按钮放在同一行 -->
      <!-- 顶部操作栏 - 标题和按钮、搜索框同一行 -->
      <div class="desktop-header">
        <div class="header-title-section">
          <h2 class="page-title">测试接头管理</h2>
          <el-tag class="count-badge" size="small" effect="plain">总数 {{ tableData.length }}</el-tag>
        </div>
        <div class="header-actions">
          <el-button type="primary" :icon="Edit" @click="dialogFormVisible = true" class="action-btn primary-btn">
            添加测试接头
          </el-button>
          <el-button :icon="Refresh" @click="handleRefresh" :loading="refreshing" class="action-btn refresh-btn">
            刷新数据
          </el-button>
          <!-- 搜索框移到右侧 -->
          <el-input v-model="search" placeholder="输入接头名称筛选" clearable class="search-input" :prefix-icon="Search" />
        </div>
      </div>

      <!-- 搜索栏与表格区域 - 一体化卡片 -->
      <div class="table-container">

        <el-table :data="filterTableData" v-loading="refreshing" class="custom-table" border stripe :header-cell-style="{
          background: '#f8fafd',
          color: '#1e293b',
          fontWeight: '600',
          fontSize: '14px',
          borderBottom: '2px solid #e9eef4'
        }" :cell-style="{
            color: '#334155',
            fontSize: '13.5px'
          }">
          <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop" :label="column.label"
            :width="column.width" header-align="center" align="center">
            <template #default="scope">
              <span v-if="column.prop === 'temp'"
                :class="['temp-badge', scope.row.temp === 'True' ? 'temp-true' : 'temp-false']">
                {{ scope.row.temp === 'True' ? '仅模板' : '正常' }}
              </span>
              <span v-else>
                {{ scope.row[column.prop] || '-' }}
              </span>
            </template>
          </el-table-column>

          <!-- 配置情况列 - 明确区分默认配置和全配置 -->
          <el-table-column prop="cfg" label="配置情况" width="120" header-align="center" align="center">
            <template #default="scope">
              <div class="config-status-wrapper">
                <el-tooltip :content="scope.row.cfg === 'True' ? '已下发全部配置数据' : '仅配置已开发功能'" placement="top">
                  <span :class="['config-badge', scope.row.cfg === 'True' ? 'config-full' : 'config-default']">
                    {{ scope.row.cfg === 'True' ? '全配置' : '默认配置' }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>

          <!-- 操作列 - 美化后 -->
          <el-table-column label="操作" width="260" header-align="center" align="center" fixed="right">
            <template #default="scope">
              <div class="action-buttons-wrapper">
                <!-- 删除 -->
                <el-popconfirm title="确认删除该接头?" @confirm="handleDelete(scope.$index, scope.row)">
                  <template #reference>
                    <el-button size="small" class="action-btn-icon delete-btn">
                      <span>删除接头</span>
                    </el-button>
                  </template>
                </el-popconfirm>

                <!-- 模板设置/删除 -->
                <el-popconfirm v-if="scope.row.temp === 'False'" title="确认设置为仅模板?" @confirm="setTemp(scope.row)">
                  <template #reference>
                    <el-button size="small" class="action-btn-icon template-set-btn">
                      <span>设置模板</span>
                    </el-button>
                  </template>
                </el-popconfirm>
                <el-popconfirm v-else title="确认取消仅模板?" @confirm="delTemp(scope.row)">
                  <template #reference>
                    <el-button size="small" class="action-btn-icon template-del-btn">
                      <span>删除模板</span>
                    </el-button>
                  </template>
                </el-popconfirm>

                <!-- 配置操作：根据当前配置状态显示不同按钮 -->
                <el-popconfirm v-if="scope.row.cfg === 'False'" title="确认切换为全配置模式?" @confirm="setDeploy(scope.row)">
                  <template #reference>
                    <el-button size="small" class="action-btn-icon config-set-btn">
                      <span>全配置</span>
                    </el-button>
                  </template>
                </el-popconfirm>
                <el-popconfirm v-else title="确认恢复默认配置?" @confirm="delDeploy(scope.row)">
                  <template #reference>
                    <el-button size="small" class="action-btn-icon config-default-btn">
                      <span>默认配置</span>
                    </el-button>
                  </template>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 配置图例说明 -->
        <div class="config-legend">
          <div class="legend-item">
            <span class="legend-dot config-full-dot"></span>
            <span class="legend-text">全配置：已下发全部配置</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot config-default-dot"></span>
            <span class="legend-text">默认配置：仅下发已开发配置</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot temp-true-dot"></span>
            <span class="legend-text">仅模板：需扫描车辆数据</span>
          </div>
        </div>
      </div>

      <!-- 添加弹窗 - 优化样式 -->
      <el-dialog v-model="dialogFormVisible" title="添加测试接头" width="520px" class="custom-dialog" destroy-on-close>
        <el-form :model="form" label-width="70px" class="dialog-form">
          <el-form-item label="接头">
            <el-input v-model="form.sn" placeholder="请输入12位接头" maxlength="12" show-word-limit clearable />
          </el-form-item>
          <el-form-item label="原因">
            <el-input v-model="form.info" type="textarea" :rows="4" placeholder="请输入添加原因" maxlength="9999"
              show-word-limit />
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitting">提交</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <!-- 手机端视图 - 同步优化配置显示 -->
    <div v-else class="mobile-view">
      <div class="mobile-header">
        <div class="header-title">
          <h5 class="page-title">测试接头管理</h5>
          <el-tag size="small" effect="dark" class="count-tag">共 {{ tableData.length }} 条</el-tag>
        </div>
        <div class="header-actions">
          <el-button class="action-btn add-btn" @click="dialogFormVisible = true">
            <el-icon>
              <Edit />
            </el-icon> 添加
          </el-button>
          <el-button class="action-btn refresh-btn" @click="handleRefresh" :loading="refreshing">
            <el-icon>
              <Refresh />
            </el-icon> 刷新
          </el-button>
        </div>
      </div>

      <!-- 搜索框 -->
      <div class="mobile-search">
        <el-input v-model="search" placeholder="搜索测试接头" clearable>
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>
      </div>

      <!-- 卡片列表 - 优化配置显示 -->
      <div class="card-list" v-loading="refreshing">
        <div v-for="item in filterTableData" :key="item.sn" class="test-card">
          <!-- 卡片头部 -->
          <div class="card-header">
            <div class="sn-info">
              <span class="sn-label">接头</span>
              <span class="sn-value">{{ item.sn }}</span>
            </div>
            <div class="status-tags">
              <!-- 模板状态 -->
              <el-tag :class="item.temp === 'True' ? 'tag-template' : 'tag-normal'" size="small" effect="light" round>
                {{ item.temp === 'True' ? '仅模板' : '正常模式' }}
              </el-tag>
            </div>
          </div>

          <!-- 卡片内容 - 新增配置情况行 -->
          <div class="card-content">
            <div class="info-row">
              <span class="info-label">产品类型</span>
              <span class="info-value">{{ item.type || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">COM</span>
              <span class="info-value">{{ item.com || '-' }}</span>
            </div>
            <!-- 新增：配置情况 -->
            <div class="info-row config-info-row">
              <span class="info-label">配置情况</span>
              <span class="info-value">
                <span :class="['mobile-config-badge', item.cfg === 'True' ? 'config-full' : 'config-default']">
                  <el-icon v-if="item.cfg === 'True'" size="12">
                    <Check />
                  </el-icon>
                  <el-icon v-else size="12">
                    <InfoFilled />
                  </el-icon>
                  {{ item.cfg === 'True' ? '全配置' : '默认配置' }}
                </span>
              </span>
            </div>
          </div>

          <!-- 卡片操作区 - 优化按钮文字 -->
          <div class="card-actions">
            <div class="action-grid">
              <!-- 删除按钮 -->
              <el-popconfirm title="确认删除?" @confirm="handleDeleteById(item)">
                <template #reference>
                  <el-button size="small" class="btn-delete">删除</el-button>
                </template>
              </el-popconfirm>

              <!-- 模板按钮 -->
              <el-popconfirm v-if="item.temp === 'False'" title="确认设置仅模板?" @confirm="setTemp(item)">
                <template #reference>
                  <el-button size="small" class="btn-template">设模板</el-button>
                </template>
              </el-popconfirm>
              <el-popconfirm v-else title="确认删除仅模板?" @confirm="delTemp(item)">
                <template #reference>
                  <el-button size="small" class="btn-template-del">删模板</el-button>
                </template>
              </el-popconfirm>

              <!-- 配置按钮 - 根据状态显示不同文字 -->
              <el-popconfirm v-if="item.cfg === 'False'" title="确认切换为全配置?" @confirm="setDeploy(item)">
                <template #reference>
                  <el-button size="small" class="btn-config">全配置</el-button>
                </template>
              </el-popconfirm>
              <el-popconfirm v-else title="确认恢复默认配置?" @confirm="delDeploy(item)">
                <template #reference>
                  <el-button size="small" class="btn-config-del">默认配置</el-button>
                </template>
              </el-popconfirm>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="filterTableData.length === 0 && !refreshing" class="empty-state">
          <el-empty description="暂无测试接头数据" />
        </div>
      </div>

      <!-- 添加弹窗 -->
      <el-dialog v-model="dialogFormVisible" title="添加测试接头" width="90%" class="mobile-dialog" destroy-on-close>
        <el-form :model="form" label-position="top">
          <el-form-item label="接头">
            <el-input v-model="form.sn" placeholder="请输入12位接头" maxlength="12" show-word-limit />
          </el-form-item>
          <el-form-item label="原因">
            <el-input v-model="form.info" type="textarea" :rows="3" placeholder="请输入添加原因" maxlength="9999"
              show-word-limit />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">提交</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, reactive } from 'vue';
import { Edit, Refresh, Search, Delete, Star, Remove, Check, Close, InfoFilled } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { getTestSn, addTestSn, deleteTestSn, addTestTempSn, deleteTestTempSn, Post_setSomeOne } from '../api/users';

export default {
  name: 'TestSn',
  setup() {
    const formLabelWidth = '60px';
    const dialogFormVisible = ref(false);
    const submitting = ref(false);
    const form = reactive({
      sn: '',
      info: ''
    });
    const refreshing = ref(false);
    const search = ref('');

    // 更新列定义 - 移除了cfg列，因为我们要单独展示
    const columns = ref([
      { prop: 'sn', label: '接头', width: '140' },
      { prop: 'type', label: '产品类型', width: '180' },
      { prop: 'com', label: 'COM', width: '100' },
      { prop: 'temp', label: '模板状态', width: '100' },
      // cfg列已被单独的配置情况列替代
    ]);

    const tableData = ref([]);

    // 响应式判断手机端
    const isMobile = ref(window.innerWidth <= 768);

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
      fetchData();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    const filterTableData = computed(() => {
      if (!search.value) return tableData.value;
      return tableData.value.filter(
        (data) => data.sn && data.sn.toLowerCase().includes(search.value.toLowerCase())
      );
    });

    const fetchData = async () => {
      refreshing.value = true;
      try {
        const response = await getTestSn();
        if (response.data) {
          columns.value = response.data.columns || columns.value;
          tableData.value = response.data.tableData || [];
        }
        ElMessage.success({ message: '数据更新成功', duration: 1500 });
      } catch (error) {
        ElMessage.error('查询测试接头失败！');
      } finally {
        refreshing.value = false;
      }
    };

    const setTemp = async (row) => {
      try {
        const value = row.sn;
        const serialNumberValue = { sn: value };
        await addTestTempSn(serialNumberValue);
        ElMessage.success('已同步到CN/US服务器中');
        row.temp = 'True';
      } catch (error) {
        ElMessage.warning('添加模板失败，请重试');
      }
    };

    const delTemp = async (row) => {
      try {
        const value = row.sn;
        await deleteTestTempSn(value);
        ElMessage.success('已同步到CN/US服务器中');
        row.temp = 'False';
      } catch (error) {
        ElMessage.warning('删除模板失败，请重试');
      }
    };

    const setDeploy = async (row) => {
      try {
        const formDeploy = { sn: row.sn };
        await Post_setSomeOne('CN Server', formDeploy, 'setTestCfg');
        ElMessage.success('已切换为全配置模式');
        row.cfg = 'True';
      } catch (error) {
        ElMessage.error('设置失败！错误原因:' + error);
      }
    };

    const delDeploy = async (row) => {
      try {
        const formDeploy = { sn: row.sn };
        await Post_setSomeOne('CN Server', formDeploy, 'DeleteTestCfg');
        ElMessage.success('已恢复为默认配置');
        row.cfg = 'False';
      } catch (error) {
        ElMessage.error('设置失败！错误原因:' + error);
      }
    };

    const handleDelete = async (index, row) => {
      try {
        const value = row.sn;
        await deleteTestSn(value);
        ElMessage.success('已同步到CN/US服务器中');
        tableData.value.splice(index, 1);
      } catch (error) {
        ElMessage.warning('删除失败，请重试');
      }
    };

    const handleDeleteById = async (row) => {
      try {
        const value = row.sn;
        await deleteTestSn(value);
        ElMessage.success('已同步到CN/US服务器中');
        const index = tableData.value.findIndex(item => item.sn === row.sn);
        if (index !== -1) tableData.value.splice(index, 1);
      } catch (error) {
        ElMessage.warning('删除失败，请重试');
      }
    };

    const handleSubmit = async () => {
      if (!form.sn || form.sn.length !== 12) {
        ElMessage.warning('接头必须为12位字符');
        return;
      }
      if (!form.info || form.info.trim() === '') {
        ElMessage.warning('原因不能为空');
        return;
      }
      submitting.value = true;
      try {
        const serialNumberValues = { sn: form.sn, reason: form.info };
        await addTestSn(serialNumberValues);
        ElMessage.success('已同步到CN/US服务器中');
        dialogFormVisible.value = false;
        form.sn = '';
        form.info = '';
        await fetchData();
      } catch (error) {
        ElMessage.warning('请求失败，请重试');
      } finally {
        submitting.value = false;
      }
    };

    const handleRefresh = async () => {
      await fetchData();
    };

    return {
      isMobile,
      search,
      columns,
      filterTableData,
      tableData,
      handleDelete,
      handleDeleteById,
      setTemp,
      delTemp,
      Edit,
      Refresh,
      Search,
      Delete,
      Star,
      Remove,
      Check,
      Close,
      InfoFilled,
      refreshing,
      dialogFormVisible,
      form,
      formLabelWidth,
      handleSubmit,
      handleRefresh,
      setDeploy,
      delDeploy,
      submitting,
    };
  }
};
</script>

<style scoped>
/* ========== 电脑端样式 ========== */
.desktop-view {
  padding: 24px 32px;
  background: #f5f7fb;
  min-height: 100vh;
}

/* 顶部操作栏 - 标题和按钮同一行，左右分布 */
.desktop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(226, 232, 240, 0.6);
}

.header-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  letter-spacing: 0.3px;
  line-height: 1.4;
  /* 移除渐变效果，使用纯色 */
  background: none;
  -webkit-background-clip: unset;
  -webkit-text-fill-color: #0f172a;
}

.count-badge {
  background: #eef2ff;
  color: #4f46e5;
  border: none;
  font-weight: 500;
  border-radius: 30px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  height: 24px;
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.header-actions .action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  border-radius: 40px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  border: none;
  line-height: 1;
  height: 40px;
}

.primary-btn {
  background: linear-gradient(145deg, #4f46e5, #6366f1);
  color: white;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
}

.primary-btn:hover {
  background: linear-gradient(145deg, #6366f1, #4f46e5);
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(79, 70, 229, 0.35);
}

.refresh-btn {
  background: white;
  color: #475569;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
}

.refresh-btn:hover {
  color: #4f46e5;
  border-color: #4f46e5;
  background: #f8faff;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(79, 70, 229, 0.12);
}

/* 表格容器 */
.table-container {
  background: white;
  border-radius: 24px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  border: 1px solid #edf2f7;
}

/* 搜索框容器 - 靠右对齐 */
.search-wrapper {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.search-input {
  width: 260px;
}

.search-input :deep(.el-input__wrapper) {
  border-radius: 40px;
  background: #f8fafc;
  box-shadow: none;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  height: 40px;
}

.search-input :deep(.el-input__wrapper:hover) {
  border-color: #4f46e5;
  background: white;
}

.search-input :deep(.el-input__inner) {
  font-size: 14px;
  height: 38px;
  line-height: 38px;
}

/* 自定义表格样式 */
.custom-table {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e9eef4;
}

.custom-table :deep(.el-table__row) {
  transition: background 0.15s;
}

.custom-table :deep(.el-table__row:hover) {
  background: #f8fafc !important;
}

.custom-table :deep(.el-table__cell) {
  padding: 8px 0;
}

/* 模板状态徽章 */
.temp-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  height: 24px;
  min-width: 60px;
}

.temp-true {
  background: #eef2ff;
  color: #4f46e5;
}

.temp-false {
  background: #f1f5f9;
  color: #64748b;
}

/* 配置情况列样式 */
.config-status-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.config-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  height: 24px;
  min-width: 80px;
  cursor: help;
  transition: all 0.2s ease;
}

.config-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.config-full {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.config-default {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

/* ========== 操作按钮组 - 修复文字居中 ========== */
.action-buttons-wrapper {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.action-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 12px !important;
  border-radius: 30px !important;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  line-height: 1;
  height: 28px;
  min-width: 70px;
  box-sizing: border-box;
}

.action-btn-icon span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  white-space: nowrap;
}

/* 删除按钮 */
.delete-btn {
  background: #fef2f2;
  color: #ef4444;
  border-color: #fee2e2;
}

.delete-btn:hover {
  background: #ef4444;
  color: white;
  border-color: #ef4444;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2);
}

/* 设置模板 */
.template-set-btn {
  background: #eef2ff;
  color: #4f46e5;
  border-color: #e0e7ff;
}

.template-set-btn:hover {
  background: #4f46e5;
  color: white;
  border-color: #4f46e5;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.2);
}

/* 删除模板 */
.template-del-btn {
  background: #fff7ed;
  color: #f97316;
  border-color: #ffedd5;
}

.template-del-btn:hover {
  background: #f97316;
  color: white;
  border-color: #f97316;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(249, 115, 22, 0.2);
}

/* 配置下发 - 设为全配置 */
.config-set-btn {
  background: #ecfdf5;
  color: #10b981;
  border-color: #d1fae5;
}

.config-set-btn:hover {
  background: #10b981;
  color: white;
  border-color: #10b981;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.2);
}

/* 恢复默认配置 */
.config-default-btn {
  background: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
}

.config-default-btn:hover {
  background: #475569;
  color: white;
  border-color: #475569;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(71, 85, 105, 0.2);
}

/* 配置图例 */
.config-legend {
  display: flex;
  gap: 24px;
  margin-top: 20px;
  padding: 12px 20px;
  background: #f8fafc;
  border-radius: 40px;
  font-size: 12px;
  border: 1px solid #e9eef4;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.config-full-dot {
  background: #059669;
  box-shadow: 0 0 0 2px #ecfdf5;
}

.config-default-dot {
  background: #64748b;
  box-shadow: 0 0 0 2px #f1f5f9;
}

.temp-true-dot {
  background: #4f46e5;
  box-shadow: 0 0 0 2px #eef2ff;
}

.legend-text {
  font-size: 12px;
  color: #334155;
  line-height: 1;
}

/* 自定义弹窗 */
.custom-dialog :deep(.el-dialog) {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.custom-dialog :deep(.el-dialog__header) {
  background: #f8fafc;
  padding: 20px 24px;
  margin: 0;
  border-bottom: 1px solid #e9eef4;
}

.custom-dialog :deep(.el-dialog__title) {
  color: #0f172a;
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
}

.custom-dialog :deep(.el-dialog__body) {
  padding: 28px 24px;
}

.custom-dialog :deep(.el-dialog__footer) {
  padding: 16px 24px 24px;
  border-top: 1px solid #e9eef4;
  background: #f8fafc;
}

.dialog-form :deep(.el-form-item__label) {
  color: #475569;
  font-weight: 500;
  line-height: 1;
  height: 32px;
  display: inline-flex;
  align-items: center;
}

.dialog-form :deep(.el-input__wrapper),
.dialog-form :deep(.el-textarea__inner) {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: none;
  padding: 8px 12px;
  display: flex;
  align-items: center;
}

.dialog-form :deep(.el-input__wrapper:hover),
.dialog-form :deep(.el-textarea__inner:hover) {
  border-color: #4f46e5;
}

.dialog-form :deep(.el-input__inner) {
  height: 36px;
  line-height: 36px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.dialog-footer .el-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 36px;
  padding: 0 20px;
  line-height: 1;
}

/* ========== 手机端样式 ========== */
.mobile-view {
  min-height: 100vh;
  background: #f8fafc;
  padding: 16px;
  padding-bottom: 80px;
}

/* 手机端顶部操作栏 */
.mobile-header {
  background: #ffffff;
  border-radius: 24px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.02);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  letter-spacing: 0.3px;
  line-height: 1;
}

.count-tag {
  background: #eef2ff !important;
  color: #4f46e5 !important;
  border: none;
  font-weight: 500;
  display: inline-flex !important;
  align-items: center;
  height: 24px;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 14px !important;
  border-radius: 40px !important;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
  height: 38px;
  line-height: 1;
}

.add-btn {
  background: #4f46e5 !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.2);
}

.refresh-btn {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
}

/* 手机端搜索框 */
.mobile-search {
  margin-bottom: 20px;
}

.mobile-search :deep(.el-input__wrapper) {
  border-radius: 40px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  height: 44px;
}

.mobile-search :deep(.el-input__inner) {
  height: 42px;
  line-height: 42px;
}

/* 手机端卡片 */
.card-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.test-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 18px;
  border: 1px solid #f1f5f9;
}

/* 卡片头部 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.sn-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sn-label {
  font-size: 12px;
  color: #64748b;
  background: #f8fafc;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 500;
  line-height: 1;
  height: 24px;
  display: inline-flex;
  align-items: center;
}

.sn-value {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1;
}

.status-tags {
  display: flex;
  gap: 6px;
}

.status-tags .el-tag {
  display: inline-flex !important;
  align-items: center;
  height: 24px;
  line-height: 1;
  border: none;
}

.tag-normal {
  background: #f1f5f9 !important;
  color: #475569 !important;
}

.tag-template {
  background: #eef2ff !important;
  color: #4f46e5 !important;
}

/* 卡片内容 */
.card-content {
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f8fafc;
  min-height: 40px;
}

.info-row:last-child {
  border-bottom: none;
}

/* 配置信息行特殊样式 */
.config-info-row {
  background: #f8fafc;
  margin-top: 4px;
  padding: 8px 10px;
  border-radius: 12px;
  border-bottom: none;
}

.info-label {
  width: 80px;
  font-size: 13px;
  color: #64748b;
  line-height: 1;
}

.info-value {
  flex: 1;
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  line-height: 1;
}

/* 手机端配置徽章 */
.mobile-config-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  height: 26px;
  min-width: 80px;
}

.mobile-config-badge.config-full {
  background: #ecfdf5;
  color: #059669;
}

.mobile-config-badge.config-default {
  background: #f1f5f9;
  color: #475569;
}

/* ========== 手机端按钮样式 - 修复文字居中 ========== */
.card-actions {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.action-grid .el-button {
  width: 100%;
  margin: 0;
  padding: 0 4px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  line-height: 1;
  height: 38px;
  border: 1px solid transparent;
}

.action-grid .el-button .el-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 2px;
}

.btn-delete {
  background: #fef2f2 !important;
  border: 1px solid #fee2e2 !important;
  color: #ef4444 !important;
}

.btn-template {
  background: #eef2ff !important;
  border: 1px solid #e0e7ff !important;
  color: #4f46e5 !important;
}

.btn-template-del {
  background: #fff7ed !important;
  border: 1px solid #ffedd5 !important;
  color: #f97316 !important;
}

.btn-config {
  background: #ecfdf5 !important;
  border: 1px solid #d1fae5 !important;
  color: #10b981 !important;
}

.btn-config-del {
  background: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  color: #475569 !important;
}

/* 空状态 */
.empty-state {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 0;
  border: 1px solid #f1f5f9;
}

.empty-state :deep(.el-empty__description) {
  line-height: 1;
}

/* 移动端弹窗 */
.mobile-dialog :deep(.el-dialog) {
  border-radius: 24px !important;
  overflow: hidden;
}

.mobile-dialog :deep(.el-dialog__header) {
  padding: 16px 20px;
  margin: 0;
  border-bottom: 1px solid #f1f5f9;
}

.mobile-dialog :deep(.el-dialog__title) {
  font-size: 16px;
  line-height: 1;
}

.mobile-dialog :deep(.el-dialog__body) {
  padding: 20px;
}

.mobile-dialog :deep(.el-dialog__footer) {
  padding: 16px 20px;
  border-top: 1px solid #f1f5f9;
}

.mobile-dialog :deep(.el-form-item) {
  margin-bottom: 16px;
}

.mobile-dialog :deep(.el-form-item__label) {
  padding-bottom: 4px;
  line-height: 1;
}

.mobile-dialog :deep(.el-input__wrapper),
.mobile-dialog :deep(.el-textarea__inner) {
  border-radius: 16px;
  display: flex;
  align-items: center;
}

.mobile-dialog :deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .desktop-view {
    display: none;
  }
}

@media screen and (min-width: 769px) {
  .mobile-view {
    display: none;
  }
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

/* ========== 克制工作台版视觉覆盖 ========== */
.desktop-view {
  padding: 18px;
  background: #eef2f6;
  min-height: 100vh;
}

.desktop-header {
  display: grid;
  grid-template-columns: minmax(220px, auto) minmax(520px, 1fr);
  gap: 16px;
  align-items: center;
  margin-bottom: 12px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #dbe3ee;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.header-title-section {
  gap: 10px;
  min-width: 0;
}

.desktop-view .page-title {
  font-size: 18px;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: 0;
  color: #0f172a;
  -webkit-text-fill-color: #0f172a;
}

.count-badge,
.count-tag {
  height: 24px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #dbe3ee;
  background: #f8fafc !important;
  color: #475467 !important;
  font-weight: 600;
}

.desktop-header .header-actions {
  display: grid;
  grid-template-columns: auto auto minmax(220px, 300px);
  justify-content: end;
  gap: 8px;
}

.header-actions .action-btn,
.action-btn {
  height: 32px;
  padding: 0 12px !important;
  border-radius: 6px !important;
  font-size: 13px;
  font-weight: 600;
  box-shadow: none !important;
  transform: none !important;
}

.primary-btn,
.add-btn {
  background: #2f80ed !important;
  border: 1px solid #2f80ed !important;
  color: #ffffff !important;
}

.primary-btn:hover,
.add-btn:hover {
  background: #175cd3 !important;
  border-color: #175cd3 !important;
}

.refresh-btn {
  background: #ffffff !important;
  color: #344054 !important;
  border: 1px solid #cfd8e3 !important;
}

.refresh-btn:hover {
  background: #f8fafc !important;
  color: #175cd3 !important;
  border-color: #98a2b3 !important;
}

.search-input {
  width: 100%;
}

.search-input :deep(.el-input__wrapper),
.mobile-search :deep(.el-input__wrapper) {
  height: 32px;
  border-radius: 6px;
  background: #ffffff;
  border: 0;
  box-shadow: 0 0 0 1px #cfd8e3 inset;
}

.search-input :deep(.el-input__wrapper:hover),
.mobile-search :deep(.el-input__wrapper:hover) {
  box-shadow: 0 0 0 1px #98a2b3 inset;
}

.search-input :deep(.el-input__inner),
.mobile-search :deep(.el-input__inner) {
  height: 30px;
  line-height: 30px;
}

.table-container {
  padding: 12px;
  background: #ffffff;
  border: 1px solid #dbe3ee;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.custom-table {
  border-radius: 8px;
  border: 1px solid #dbe3ee;
  box-shadow: none;
}

.custom-table :deep(.el-table__cell) {
  padding: 6px 0;
}

.custom-table :deep(.cell) {
  line-height: 20px;
}

.temp-badge,
.config-badge,
.mobile-config-badge {
  height: 22px;
  min-width: 64px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: none !important;
  transform: none !important;
}

.temp-true,
.tag-template {
  background: #eff6ff !important;
  color: #175cd3 !important;
  border: 1px solid #bfdbfe !important;
}

.temp-false,
.tag-normal {
  background: #f2f4f7 !important;
  color: #475467 !important;
  border: 1px solid #d0d5dd !important;
}

.config-full,
.mobile-config-badge.config-full {
  background: #ecfdf3 !important;
  color: #027a48 !important;
  border: 1px solid #abefc6 !important;
}

.config-default,
.mobile-config-badge.config-default {
  background: #f8fafc !important;
  color: #475467 !important;
  border: 1px solid #dbe3ee !important;
}

.action-buttons-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 74px);
  gap: 6px;
  justify-content: center;
}

.action-btn-icon {
  width: 74px;
  min-width: 74px;
  height: 28px;
  padding: 0 !important;
  border-radius: 6px !important;
  font-size: 12px;
  font-weight: 600;
  box-shadow: none !important;
  transform: none !important;
}

.delete-btn {
  background: #fff5f5 !important;
  color: #d92d20 !important;
  border-color: #fecdca !important;
}

.delete-btn:hover {
  background: #d92d20 !important;
  color: #ffffff !important;
  border-color: #d92d20 !important;
}

.template-set-btn {
  background: #eff6ff !important;
  color: #175cd3 !important;
  border-color: #bfdbfe !important;
}

.template-set-btn:hover {
  background: #175cd3 !important;
  color: #ffffff !important;
  border-color: #175cd3 !important;
}

.template-del-btn {
  background: #fff7ed !important;
  color: #c2410c !important;
  border-color: #fed7aa !important;
}

.template-del-btn:hover {
  background: #c2410c !important;
  color: #ffffff !important;
  border-color: #c2410c !important;
}

.config-set-btn {
  background: #ecfdf3 !important;
  color: #027a48 !important;
  border-color: #abefc6 !important;
}

.config-set-btn:hover {
  background: #027a48 !important;
  color: #ffffff !important;
  border-color: #027a48 !important;
}

.config-default-btn {
  background: #f8fafc !important;
  color: #475467 !important;
  border-color: #dbe3ee !important;
}

.config-default-btn:hover {
  background: #475467 !important;
  color: #ffffff !important;
  border-color: #475467 !important;
}

.config-legend {
  margin-top: 10px;
  padding: 8px 10px;
  gap: 18px;
  background: #f8fafc;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
}

.legend-dot {
  width: 8px;
  height: 8px;
  box-shadow: none;
}

.legend-text {
  color: #667085;
}

.custom-dialog :deep(.el-dialog),
.mobile-dialog :deep(.el-dialog) {
  border-radius: 8px !important;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.14);
}

.custom-dialog :deep(.el-dialog__header),
.custom-dialog :deep(.el-dialog__footer),
.mobile-dialog :deep(.el-dialog__header),
.mobile-dialog :deep(.el-dialog__footer) {
  background: #f8fafc;
  border-color: #e4eaf2;
}

.dialog-form :deep(.el-input__wrapper),
.dialog-form :deep(.el-textarea__inner),
.mobile-dialog :deep(.el-input__wrapper),
.mobile-dialog :deep(.el-textarea__inner) {
  border-radius: 6px;
  box-shadow: 0 0 0 1px #cfd8e3 inset;
}

.mobile-view {
  background: #eef2f6;
  padding: 12px;
  padding-bottom: 80px;
}

.mobile-header,
.test-card,
.empty-state {
  border-radius: 8px;
  border: 1px solid #dbe3ee;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.mobile-header {
  padding: 12px;
  margin-bottom: 10px;
}

.mobile-view .page-title {
  font-size: 16px;
  font-weight: 700;
}

.mobile-search {
  margin-bottom: 10px;
}

.card-list {
  gap: 10px;
}

.test-card {
  padding: 12px;
}

.card-header {
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.sn-label {
  border-radius: 6px;
  background: #f2f4f7;
  color: #667085;
}

.sn-value {
  font-weight: 700;
}

.config-info-row {
  border-radius: 8px;
}

.card-actions {
  margin-top: 10px;
  padding-top: 10px;
}

.action-grid .el-button {
  height: 34px;
  border-radius: 6px;
  font-weight: 600;
}

.btn-delete {
  background: #fff5f5 !important;
  border-color: #fecdca !important;
  color: #d92d20 !important;
}

.btn-template,
.btn-template-del {
  background: #eff6ff !important;
  border-color: #bfdbfe !important;
  color: #175cd3 !important;
}

.btn-config {
  background: #ecfdf3 !important;
  border-color: #abefc6 !important;
  color: #027a48 !important;
}

.btn-config-del {
  background: #f8fafc !important;
  border-color: #dbe3ee !important;
  color: #475467 !important;
}

@media screen and (max-width: 1180px) {
  .desktop-header {
    grid-template-columns: 1fr;
  }

  .desktop-header .header-actions {
    justify-content: start;
    grid-template-columns: auto auto minmax(260px, 360px);
  }
}

/* ========== 轻量功能色按钮覆盖 ========== */
.primary-btn,
.add-btn,
.refresh-btn,
.action-btn-icon,
.action-grid .el-button {
  background: #ffffff !important;
  border: 1px solid #d9e2ec !important;
  color: #1f3b57 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  font-weight: 600;
  letter-spacing: 0;
}

.primary-btn,
.add-btn {
  background: #409eff !important;
  border-color: #409eff !important;
  color: #ffffff !important;
}

.primary-btn:hover,
.add-btn:hover,
.refresh-btn:hover,
.action-btn-icon:hover,
.action-grid .el-button:hover {
  background: #eef5ff !important;
  border-color: #b7d8ff !important;
  color: #1f6fbd !important;
  box-shadow: none !important;
}

.primary-btn:hover,
.add-btn:hover {
  background: #2f8ee8 !important;
  border-color: #2f8ee8 !important;
  color: #ffffff !important;
}

.delete-btn,
.btn-delete,
.template-set-btn,
.btn-template,
.template-del-btn,
.btn-template-del,
.config-default-btn,
.btn-config-del {
  background: #ffffff !important;
}

.delete-btn,
.btn-delete {
  border-color: #fbc4c4 !important;
  color: #f56c6c !important;
}

.template-set-btn,
.btn-template {
  border-color: #b3d8ff !important;
  color: #409eff !important;
}

.template-del-btn,
.btn-template-del {
  border-color: #f3d19e !important;
  color: #e6a23c !important;
}

.config-set-btn,
.btn-config {
  background: #67c23a !important;
  border-color: #67c23a !important;
  color: #ffffff !important;
}

.config-default-btn,
.btn-config-del {
  background: #909399 !important;
  border-color: #909399 !important;
  color: #ffffff !important;
}

.delete-btn:hover,
.btn-delete:hover,
.template-set-btn:hover,
.btn-template:hover,
.template-del-btn:hover,
.btn-template-del:hover {
  background: #fdf6ec !important;
  border-color: #e6a23c !important;
  color: #b88230 !important;
}

.delete-btn:hover,
.btn-delete:hover {
  background: #fef0f0 !important;
  border-color: #f56c6c !important;
  color: #d94d4d !important;
}

.template-set-btn:hover,
.btn-template:hover {
  background: #ecf5ff !important;
  border-color: #409eff !important;
  color: #2f8ee8 !important;
}

.config-set-btn:hover,
.btn-config:hover {
  background: #5daf34 !important;
  border-color: #5daf34 !important;
  color: #ffffff !important;
}

.config-default-btn:hover,
.btn-config-del:hover {
  background: #82848a !important;
  border-color: #82848a !important;
  color: #ffffff !important;
}

.action-btn-icon.is-disabled,
.action-grid .el-button.is-disabled {
  background: #eef1f3 !important;
  border-color: #c8d0d8 !important;
  color: #98a2ad !important;
  box-shadow: none !important;
}
</style>
